import { useMemo } from 'react';
import { useMemoizedFn } from 'ahooks';
import useMediaFile from '../../MediaPreview/useMediaFile';
import { useContextMenu } from '../ContextMenu';

/**
 * 消息编辑器媒体与粘贴
 * 单一职责：粘贴文件处理、右键菜单（复制/粘贴文本与文件）
 */
export function useMessageEditorMedia(
  conversation: Conversation.Conversation,
  insertText: (text: string) => void,
) {
  const fileManager = useMediaFile(conversation);

  const { showContextMenu, contextMenu } = useContextMenu(
    useMemo(
      () => ({
        onPasteText: insertText,
        onPasteFile: fileManager,
      }),
      [insertText, fileManager],
    ),
  );

  const handlePaste = useMemoizedFn((e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    if (e?.clipboardData?.items?.length > 0) {
      const files = Array.from(e.clipboardData.items).reduce<File[]>((res, item) => {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) res.push(file);
        }
        return res;
      }, []);
      if (files.length > 0) {
        e.preventDefault();
      }
      fileManager(files);
    }
  });

  const handleContextMenu = useMemoizedFn((e: React.MouseEvent) => {
    e.preventDefault();
    showContextMenu(e);
  });

  return {
    fileManager,
    handlePaste,
    showContextMenu,
    contextMenu,
    handleContextMenu,
  };
}
